<template>
  <Modal
      class="login-modal common-modal"
      v-model:visible="modalVisible"
      :footer="null" 
      :closable="false"
    > 
      <div class="close" @click="closeModal"><svg-icon name="close"></svg-icon></div>
      <div class="modal-container">
        <div class="modal_left_content">
          <ul>
            <li>100000+精品模板</li>
            <li>20W+免费高清素材分享</li>
            <li>免费在线编辑</li>
            <li>高清无水印下载</li>
            <li>免费PPT组合下载</li>
            <li>免费导航共享</li>
            <li>专属客服咨询服务</li>
          </ul>
        </div>

        <div class="modal_right_content weixin_content" v-if="modalType === 'wx'">
          <div class="modal-header">
              <div class="weixinQrcode" @click="showContent('login')">
                  <div class="account_login_tips"></div>
              </div>
              <span class="title">账号密码登录</span>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          </div>
          <div class="modal-body">
              <div class="login_title">
                <h2>微信安全登录注册</h2>
                <p>微信、手机号是独立的账户，账号信息不互通</p>
              </div>
              <div class="weixinqrcode">
                  <img :src="url" width="170"/>
              </div>
              <div class="tips">微信扫码快速注册或登录</div>
          </div>
          <div class="modal_way">
            <ul>
              <li class="qq"></li>
              <li class="weibo"></li>
              <li class="mobile" @click="showContent('login')"></li>
            </ul>
          </div>
          <div class="modal_reg_bottom">
              <span>登录或注册即视为同意 <a href="https://ppt.101dao.com/user_service/?type=2" target="_blank">用户协议</a> 和 <a href="https://ppt.101dao.com/user_service/?type=2" target="_blank">隐私政策</a></span>
              <a data-dismiss="modal" data-toggle="modal" data-target="#accountLoginModal" @click="showContent('login')">直接登录</a>
          </div>
        </div>
        <div class="modal_right_content login_content" v-if="modalType === 'login'">
          <div class="modal-header">
              <div class="weixinQrcode" @click="showContent('wx')">
                  <div class="weixin"></div>
              </div>
              <span class="title">微信登录</span>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          </div>
          <div class="modal-body">
            <div class="login_title">
              <h2>账号密码登录</h2>
              <p>登录开启美好新世界</p>
            </div>
            <div class="account_input">
              <input type="number" v-model="Account" placeholder="请输入手机号">
            </div>
            <div class="account_password">
              <input type="password" v-model="Password" class="" placeholder="请输入密码">
            </div>
            <div class="other">
              <span @click="showContent('login_code')" >手机验证码登录</span>
              <span @click="showContent('forgotpass')" >忘记密码？</span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click.prevent="handleRegister()">登录</button>
          </div>
          <div class="modal_way">
            <ul>
              <li class="wx" @click="showContent('wx')"></li>
            </ul>
          </div>
          <div class="modal_reg_bottom">
              <span>登录或注册即视为同意 <a href="https://ppt.101dao.com/user_service/?type=2" target="_blank">用户协议</a> 和 <a href="https://ppt.101dao.com/user_service/?type=2" target="_blank">隐私政策</a></span>
              <a @click="showContent('register')">手机号注册</a>
          </div>
        </div>
        <div class="modal_right_content login_content" v-if="modalType === 'login_code'">
          <div class="modal-header">
              <div class="weixinQrcode" @click="showContent('wx')">
                  <div class="weixin"></div>
              </div>
              <span class="title">微信登录</span>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          </div>
          <div class="modal-body">
            <div class="login_title">
              <h2>手机验证码登录</h2>
              <p>登录开启美好新世界</p>
            </div>
            <div class="account_input">
              <input type="number" v-model="Account" placeholder="请输入手机号">
            </div>
            <div class="mobile_input mobile_code_input">
                <input type="number" name="verifyCode" class="" v-model="Code" placeholder="请输入验证码">
                <span class="get_mobile_code" @click="getLoginCode" v-if="countShow">获取验证码</span><span class="get_mobile_code" v-else>{{count}}s</span>
            </div>
            <div class="other">
              <span @click="showContent('login')">密码登录</span>
              <span></span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click.prevent="handleLogin()">登录</button>
          </div>
          <div class="modal_way">
            <ul>
              <li class="wx" @click="showContent('wx')"></li>
            </ul>
          </div>
          <div class="modal_reg_bottom">
              <span>登录或注册即视为同意 <a href="https://ppt.101dao.com/user_service/?type=2" target="_blank">用户协议</a> 和 <a href="https://ppt.101dao.com/user_service/?type=2" target="_blank">隐私政策</a></span>
              <a @click="showContent('register')">手机号注册</a>
          </div>
        </div>
        <div class="modal_right_content register_content" v-if="modalType === 'register'">
          <div class="modal-header">
              <div class="weixinQrcode" @click="showContent('login')">
                  <div class="account_login_tips"></div>
              </div>
              <span class="title">账号密码登录</span>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          </div>
          <div class="modal-body">
            <div class="login_title">
              <h2>手机号注册</h2>
              <p>注册开启美好新世界</p>
            </div>
            <div class="mobile_input">
                <input type="number" name="mobile" v-model="Account" placeholder="请输入手机号">
            </div>
            <div class="mobile_input mobile_code_input">
                <input type="number" name="verifyCode" v-model="Code" class="" placeholder="请输入验证码">
                <span class="get_mobile_code" @click="getRegCode" v-if="countShow">获取验证码</span><span class="get_mobile_code" v-else>{{count}}s</span>
            </div>
            <div class="account_password">
                <input type="password" name="password" class="" v-model="Password" placeholder="请输入密码(6-12数字或字母组合)">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click.prevent="handleLogin()">注册</button>
          </div>
          <div class="modal_reg_bottom">
              <span>登录或注册即视为同意 <a href="https://ppt.101dao.com/user_service/?type=2" target="_blank">用户协议</a> 和 <a href="https://ppt.101dao.com/user_service/?type=2" target="_blank">隐私政策</a></span>
              <a @click="showContent('login')">直接登录</a>
          </div>
        </div>
        <div class="modal_right_content forgotpass_content" v-if="modalType === 'forgotpass'">
          <div class="modal-header">
              <div class="weixinQrcode" @click="showContent('login')">
                  <div class="account_login_tips"></div>
              </div>
              <span class="title">账号密码登录</span>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          </div>
          <div class="modal-body">
            <div class="login_title">
              <h2 style="margin-bottom: 20px;">忘记密码</h2>
              
            </div>
            <div class="mobile_input">
                <input type="number" name="mobile" v-model="Account" placeholder="请输入手机号">
            </div>
            <div class="mobile_input mobile_code_input">
                <input type="number" name="verifyCode" v-model="Code" class="" placeholder="请输入验证码">
                <span class="get_mobile_code" @click="getPasswordCode" v-if="countShow">获取验证码</span><span class="get_mobile_code" v-else>{{count}}s</span>
            </div>
            <div class="account_password">
              <input type="password" name="password" class="" v-model="Password" placeholder="请输入密码(6-12数字或字母组合)">
            </div>
          <div class="account_password">
              <input type="password" name="password" class="" v-model="rePassword" placeholder="请再次输入密码(6-12数字或字母组合)">
            </div>
            
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="handleFindPassword">找回密码</button>
          </div>
          <div class="modal_reg_bottom">
              <span>登录或注册即视为同意 <a href="/user_service/" target="_blank">用户协议</a> 和 <a href="/user_service/" target="_blank">会员服务协议</a></span>
              <a @click="showContent('login')">直接登录</a>
          </div>
        </div>
        <div class="modal_right_content forgotpass_content" v-if="modalType === 'modifypass'">
          <div class="modal-body" style="padding-top: 80px;">
            <div class="login_title">
              <h2 style="margin-bottom: 70px;">修改密码</h2>
              
            </div>
            <div class="account_password">
              <input type="password" name="password" class="" v-model="Password" placeholder="请输入原密码">
            </div>
          <div class="account_password">
              <input type="password" name="password" class="" v-model="rePassword" placeholder="请输入新密码(6-12数字或字母组合)">
            </div>
            
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="handleModifyPassword">找回密码</button>
          </div>
        </div>
        <div class="modal_right_content weixin_content" v-if="modalType === 'bindWx'">
   
          <div class="modal-body">
              <div class="login_title" style="margin-top: 120px;">
                <h2>绑定微信公众号</h2>
              </div>
              <div class="weixinqrcode">
                  <img :src="url" width="170"/>
              </div>
              <div class="tips">打开 微信 扫描二维码绑定</div>
          </div>
        </div>
        <div class="modal_right_content weixin_content" v-if="modalType === 'unbindWx'">
   
          <div class="modal-body">
              <div class="login_title" style="margin-top: 120px;">
                <h2>解绑微信公众号</h2>
              </div>
              <div class="weixinqrcode">
                  <img :src="url" width="170"/>
              </div>
              <div class="tips">打开 微信 扫描二维码绑定</div>
          </div>
        </div>
        <div class="modal_right_content register_content" v-if="modalType === 'changeMobile'">
          <div class="modal-body" style="margin-top: 80px;">
            <div class="login_title">
              <h2>更换手机号</h2>
              <p>修改成功后，你可以直接使用手机号登录象刀产品</p>
            </div>
            <div class="mobile_input">
                <input type="number" name="mobile" v-model="Account" placeholder="请输入原始手机号">
            </div>
            <div class="mobile_input">
                <input type="number" name="mobile" v-model="Account1" placeholder="请输入新手机号">
            </div>
            <div class="mobile_input mobile_code_input">
                <input type="number" name="verifyCode" v-model="Code" class="" placeholder="请输入验证码">
                <span class="get_mobile_code" @click="getChangeMobileCode" v-if="countShow">获取验证码</span><span class="get_mobile_code" v-else>{{count}}s</span>
            </div>
    
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click.prevent="changeMobile()">修改</button>
          </div>
        </div>
        <div class="modal_right_content register_content" v-if="modalType === 'bindMobile'">
          <div class="modal-body" style="margin-top: 80px;">
            <div class="login_title">
              <h2>绑定手机号</h2>
              <p>绑定成功后，你可以直接使用手机号登录象刀产品</p>
            </div>
            <div class="mobile_input">
                <input type="number" name="mobile" v-model="Account" placeholder="请输入手机号">
            </div>
            <div class="mobile_input mobile_code_input">
                <input type="number" name="verifyCode" v-model="Code" class="" placeholder="请输入验证码">
                <span class="get_mobile_code" @click="getBindMobileCode" v-if="countShow">获取验证码</span><span class="get_mobile_code" v-else>{{count}}s</span>
            </div>
            <div class="account_password">
              <input type="password" name="password" class="" v-model="Password" placeholder="请输入密码">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click.prevent="bindMobile()">修改</button>
          </div>
        </div>
    </div>
  </Modal>

</template>
<script lang="ts">
import { defineComponent, computed, reactive, toRefs, ref, watch } from 'vue'
import { MutationTypes, useStore } from '@/store'
import { message } from 'ant-design-vue'
import router from '@/router'
// 引入接口
import { UserService } from '@/api/user'
export default defineComponent({
  setup() {
    const store = useStore()
    
    let checkTime:any = null
    let timer:any = null
    const count = ref()
    const countShow = ref(true)
    const modalVisible = computed(() => store.state.loginModalState)
    const modalType = computed(() => store.state.loginModalType)
    const closeModal = () => {
      store.commit(MutationTypes.SET_LOGIN_MODAL_STATE, false)
      clearInterval(checkTime)
      checkTime = null
    }
    const wechat = reactive({
      scene_str:'',
      url:'http://39.108.138.63:5001/static/tmp/weixinqrcode.jpg',
    })
    const state = reactive({
      Account: '', // 账户
      Account1:'',
      Password: '',
      rePassword:'',
      Code:''
    })

    const handleRegister = async () => {
      const loginParams = {
        loginName: state.Account,
        password: state.Password,
      }
      const res = await UserService.resgister(loginParams)
      if (res.data.state === 2) {
        message.success(res.data.msg)
        router.go(0)
      } 
      else {
        message.error(res.data.msg)
      }
    }
    const changeMobile = async () => {
      const loginParams = {
        newMobile: state.Account1,
        verifyCode: state.Code,
      }
      const res = await UserService.changeMobile(loginParams)
      if (res.data.state === 2) {
        message.success(res.data.msg)
        setTimeout(() => {
          // setCookie('userid','', -1)
          
          router.go(0)
        }, 1000)
      } 
      else {
        message.error(res.data.msg)
      }
    }
    const bindMobile = async () => {
      const loginParams = {
        mobile: state.Account,
        verifyCode: state.Code,
        password:state.Password
      }
      const res = await UserService.bindMobile(loginParams)
      if (res.data.state === 2) {
        message.success(res.data.msg)
        setTimeout(() => {
          // setCookie('userid','', -1)
          
          router.go(0)
        }, 1000)
      } 
      else {
        message.error(res.data.msg)
      }
    }
    const handleLogin = async () => {
      const loginParams = {
        mobile: state.Account,
        password: state.Password,
        verifyCode:state.Code
      }
      const res = await UserService.login(loginParams)
      if (res.data.state === 2) {
        message.success(res.data.msg)
        router.go(0)
      } 
      else {
        message.error(res.data.msg)
      }
    }
    const handleFindPassword = async () => {
      const loginParams = {
        mobile: state.Account,
        newPassword: state.Password,
        reNewPassword:state.rePassword,
        verifyCode:state.Code
      }
      const res = await UserService.findPassword(loginParams)
      if (res.data.state === 2) {
        message.success(res.data.msg)
        showContent('login')
      } 
      else {
        message.error(res.data.msg)
      }
    }
    const handleModifyPassword = async () => {
      const loginParams = {
        orgPassword: state.Password,
        newPassword:state.rePassword,
      }
      const res = await UserService.modifyPassword(loginParams)
      if (res.data.state === 2) {
        message.success(res.data.msg)
        // setCookie('userid','', -1)
        
        router.go(0)
      } 
      else {
        message.error(res.data.msg)
      }
    }
     
    const showContent = (type:string) => {
      clearInterval(checkTime)
      checkTime = null
      if (type === 'wx') {
        getWechatScan('signin')
      }
      store.commit(MutationTypes.SET_LOGIN_MODAL_TYPE, type)
      
    }
    const getLoginCode = async () => {
      const TIME_COUNT = 60
      if (!timer) {
        count.value = TIME_COUNT
        countShow.value = false
        timer = setInterval(() => {
          if (count.value > 0 && count.value <= TIME_COUNT) {
            count.value--
          }
          else {
            countShow.value = true
            clearInterval(timer)
            timer = null
          }
        },1000)
      }
      const loginParams = {
        mobile: state.Account,
      }
      await UserService.getLoginCode(loginParams)
    }
    const getRegCode = async () => {
      const TIME_COUNT = 60
      if (!timer) {
        count.value = TIME_COUNT
        countShow.value = false
        timer = setInterval(() => {
          if (count.value > 0 && count.value <= TIME_COUNT) {
            count.value--
          }
          else {
            countShow.value = true
            clearInterval(timer)
            timer = null
          }
        },1000)
      }
      const loginParams = {
        mobile: state.Account,
      }
      await UserService.getRegCode(loginParams)
    }
    const getPasswordCode = async () => {
      const TIME_COUNT = 60
      if (!timer) {
        count.value = TIME_COUNT
        countShow.value = false
        timer = setInterval(() => {
          if (count.value > 0 && count.value <= TIME_COUNT) {
            count.value--
          }
          else {
            countShow.value = true
            clearInterval(timer)
            timer = null
          }
        },1000)
      }
      const loginParams = {
        mobile: state.Account,
      }
      await UserService.getPasswordCode(loginParams)
    }
    const getChangeMobileCode = async () => {
      const TIME_COUNT = 60
      if (!timer) {
        count.value = TIME_COUNT
        countShow.value = false
        timer = setInterval(() => {
          if (count.value > 0 && count.value <= TIME_COUNT) {
            count.value--
          }
          else {
            countShow.value = true
            clearInterval(timer)
            timer = null
          }
        },1000)
      }
      const loginParams = {
        newMobile: state.Account1,
      }
      await UserService.getChangeMobileCode(loginParams)
    }
    const getBindMobileCode = async () => {
      const TIME_COUNT = 60
      if (!timer) {
        count.value = TIME_COUNT
        countShow.value = false
        timer = setInterval(() => {
          if (count.value > 0 && count.value <= TIME_COUNT) {
            count.value--
          }
          else {
            countShow.value = true
            clearInterval(timer)
            timer = null
          }
        },1000)
      }
      const loginParams = {
        mobile: state.Account,
      }
      await UserService.getBindMobileCode(loginParams)
    }
    
    const getWechatScan = async (type: string | undefined) => {
      const loginParams = {
        opt:type
      }
      const res = await UserService.wechatScan(loginParams)
      if (res.data.state === 2) {
        wechat.scene_str = res.data.data.scene_str
        wechat.url = res.data.data.url
        if (!checkTime) {
          checkTime = setInterval(() => {
            checkWechat()
          }, 2000)
        }

      }
      else {
        message.error(res.data.msg)
      }
    }
    const checkWechat = async () => {
      const loginParams = {
        scene_str: wechat.scene_str
      }
      const res = await UserService.wechatCheck(loginParams)
      if (res.data.state === 2) {
        clearInterval(checkTime)
        router.go(0)
        checkTime = null
      }
      else {
        if (res.data.msg !== '等待微信回调') {
          message.error(res.data.msg)
          clearInterval(checkTime)
          checkTime = null
          
        }
        
      }
    }
    watch(() => modalVisible.value,() => {
      if (modalType.value === 'wx' && modalVisible.value) {
        getWechatScan('signin')
      }
      if (modalType.value === 'bindWx' && modalVisible.value) {
        getWechatScan('bind')
      }
      if (modalType.value === 'unbindWx' && modalVisible.value) {
        getWechatScan('unbind')
      }
    })

    return {
      closeModal,
      modalVisible,
      modalType,
      ...toRefs(state),
      ...toRefs(wechat),
      handleRegister,
      handleLogin,
      handleFindPassword,
      handleModifyPassword,
      showContent,
      getLoginCode,
      getRegCode,
      getPasswordCode,
      getChangeMobileCode,
      getBindMobileCode,
      changeMobile,
      bindMobile,
      count,
      countShow
    }
  },
})
</script>


